export default "__VITE_ASSET__E7OumE_U__"